{
  "empty": "No leads yet",
  "noMatch": "Nothing matches these filters",
  "columns": {
    "created": "Time",
    "type": "Type",
    "country": "Country",
    "reason": "Reason",
    "ip": "IP",
    "source": "Source"
  },
  "filters": {
    "search": "IP",
    "served": "Page"
  },
  "type": {
    "lead": "Lead",
    "white": "White",
    "black": "Black",
    "bot": "Bot",
    "abuse": "Abuse"
  },
  "detail": {
    "title": "Lead",
    "groups": {
      "classification": "Classification",
      "geo": "Geo",
      "device": "Device",
      "network": "Network",
      "headers": "Headers"
    },
    "fields": {
      "type": "Type",
      "blockReason": "Block reason",
      "page": "Page",
      "domain": "Domain",
      "uri": "URI",
      "source": "Source",
      "country": "Country",
      "city": "City",
      "lang": "Language",
      "deviceType": "Device type",
      "deviceOs": "OS",
      "ip": "IP",
      "isp": "ISP",
      "isVpn": "VPN",
      "dns": "DNS",
      "referer": "Referer",
      "userAgent": "User-Agent",
      "acceptLanguage": "Accept-Language",
      "xForwardedFor": "X-Forwarded-For",
      "utms": "UTM",
      "secChUa": "Sec-CH-UA",
      "secChUaPlatform": "Platform",
      "secFetchSite": "Fetch-Site",
      "secChUaMobile": "Sec-CH-UA-Mobile",
      "secFetchMode": "Fetch-Mode",
      "secFetchDest": "Fetch-Dest",
      "campaign": "Campaign"
    },
    "yes": "Yes",
    "no": "No"
  },
  "blockReason": {
    "ua": "User agent",
    "ip_blocked": "Blacklisted IP",
    "abuse_ip": "IP with bad reputation",
    "isp": "Blacklisted ISP",
    "vpn": "VPN network",
    "dns": "Reverse DNS",
    "campaign_dns": "Campaign reverse DNS",
    "country": "Country not allowed",
    "language": "Language not allowed",
    "device": "Device not allowed",
    "os": "OS not allowed",
    "source": "Source disabled",
    "white_only": "White-only mode"
  },
  "page": {
    "white": "White",
    "black": "Black"
  }
}
